<div #animationElt *ngIf="animationUrl" [ngClass]="{ animation: animationUrl }" class="lottie"></div>